import React from 'react'

const Pagination = ({selected, clickFunction}) => {
  return (
    <div className={ `pagination ${selected ? '' : 'apl-badge'}`} onClick={ clickFunction }></div>
  )
}

export default Pagination


// WEBPACK FOOTER //
// ./components/common/global-carousel/Pagination.js